import { Button, Card, CardContent, Skeleton, Stack, styled, Typography } from "~/common/mui";
import { CORNER_EXTRA_LARGE } from "~/common/components/icon/Corners";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

const SearchResultSkeleton = ({ className }: { className?: string }) => {
  return (
    <Card className={className}>
      <Content>
        <ImageSkeleton />
        <Stack gap={{ phone: 1, "desktop-s": 3 }}>
          <Typography variant="titleLarge">
            <Skeleton width={"50%"} />
          </Typography>

          <Stack gap={1}>
            <Typography variant="bodyLarge">
              <Skeleton width={"70%"} />
            </Typography>

            <Typography variant="bodyLarge">
              <Skeleton width={"60%"} />
            </Typography>
          </Stack>
        </Stack>

        <Stack gap={2}>
          <ButtonSkeleton fullWidth />
          <ButtonSkeleton fullWidth />
        </Stack>
      </Content>
    </Card>
  );
};

export default SearchResultSkeleton;

const ImageSkeleton = () => {
  const isDesktop = useIsMinDesktopSize();
  const height = isDesktop ? 112 : 120;
  return <Skeleton variant="rounded" width={160} height={height} />;
};

const ButtonSkeleton = ({ fullWidth }: { fullWidth?: boolean }) => (
  <Skeleton variant="rectangular" width={fullWidth ? "100%" : undefined} sx={{ borderRadius: CORNER_EXTRA_LARGE }}>
    <Button>.</Button>
  </Skeleton>
);

const Content = styled(CardContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  [theme.breakpoints.up("desktop-s")]: {
    display: "grid",
    gridTemplateColumns: "160px 1fr 220px",
    gap: "24px",
  },
}));
